<ng-container *ngIf="!isLoading">
  <img *ngIf="hasAvatar; else ngxAvatar" [style.height.px]="size" [style.width.px]="size" class="avatar" [src]="imageSrc" />
  
  <ng-template #ngxAvatar>
    <ngx-avatar [name]="name" [bgColor]="color" [size]="size"></ngx-avatar>
  </ng-template>
</ng-container>

<span class="loading-icon-small" *ngIf="isLoading"></span>
